import is from '@sindresorhus/is';
import type { FunctionComponent } from 'react';

import { isKnownChangeLogEventDetail } from '~/shared/data-contract/job-architecture-history';
import { Timeline } from '~/ui/core/timeline/Timeline';

import { useJobArchitectureUrlTileActions } from '../url-tiles/use-job-architecture-url-tile-actions';
import type { TimelineItem } from './use-changelog-data';

type TimelineNavigableItemProps = {
    readonly item: TimelineItem;
};

export const TimelineNavigableItem: FunctionComponent<TimelineNavigableItemProps> = ({ item }) => {
    const entityId = item.entityId ?? '';
    const { openCompareTile, openJobProfileTile } = useJobArchitectureUrlTileActions();

    const itemType = item.entityType === 'level' ? 'job-level' : 'job-role';

    const handleClick = (): void => {
        if (!is.nonEmptyString(entityId)) {
            return;
        }

        if (isKnownChangeLogEventDetail(item.eventDetails) && item.eventDetails.type === 'version_created') {
            openCompareTile({
                profileId: entityId,
                type: itemType,
                versionA: item.eventDetails.version.toString(),
                versionB: (item.eventDetails.version - 1).toString(),
            });

            return;
        }

        openJobProfileTile({
            mode: 'view',
            profileId: entityId,
            type: itemType,
        });
    };

    const isClickable = is.nonEmptyString(item.entityId);

    return (
        <Timeline.Item
            icon={item.icon}
            itemSubtitle={item.subtitle}
            itemTitle={item.title}
            onClick={isClickable ? handleClick : undefined}
        >
            <Timeline.Footer>{item.footerItems}</Timeline.Footer>
        </Timeline.Item>
    );
};
